(function () {
    'use strict';

    angular
        .module('app')
        .controller('WinbackOffersListController', WinbackOffersListController);

    WinbackOffersListController.$inject = ['API', 'alert', 'debug', 'i18n', 'ListViewSearchExtension'];

    function WinbackOffersListController(API, alert, debug, i18n, ListViewSearchExtension) {
        var vm = this;

        ListViewSearchExtension.extendScope(vm);

        vm.searchTerm = '';
        vm.page = 1;
        vm.perPage = 20;
        vm.listMeta = {};
        vm.loadingState = {
            winbackIsLoading: false
        };
        vm.listObject.filter = {
            type: ''
        };
        vm.loadResources = loadResources;
        vm.openRemoveModal = openRemoveModal;

        activate();

        function activate() {
            loadResources();
        }

        function openRemoveModal(offer) {
            var promise = alert.confirm('remove-item');

            promise.then(function() {
                var removePromise = API.WinbackOffer.recycle({ id: offer.id }).$promise;

                removePromise.then(function() {
                    var index = vm.winbackOffers.findIndex(function(item) {
                        return item.id === offer.id;
                    });
                    vm.winbackOffers.splice(index, 1);
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('OFFER_RECYCLED') });
                }, function() {});
            }, function() {});
        }

        function loadResources(skipCharacterLimit) {
            var searchObject = {
                'q': vm.searchTerm,
                'page': vm.page,
                'per-page': vm.perPage,
            };

            if (vm.listObject.filter.type) {
                searchObject.type = vm.listObject.filter.type;
            }

            if (vm.listObject.searchTerm && (vm.listObject.searchTerm.length > 2 || skipCharacterLimit)) {
                searchObject.q = vm.listObject.searchTerm;
            }

            var promise = API.WinbackOffer.search(searchObject).$promise;

            vm.onSearch();

            if (promise) {
                vm.loadingState.winbackIsLoading = true;
                promise.then(function (response) {
                    vm.winbackOffers = response.items;
                    vm.listMeta = response._meta;
                    vm.loadingState.winbackIsLoading = false;
                }, function (response) {
                    debug.log(response);
                    vm.loadingState.winbackIsLoading = false;
                });
            }
        }
    }
})();